/* BB theme core: dialogs, accordions, media slots, announcement rotation, header and the AJAX cart. */
const BB = (window.BB = window.BB || {});
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

BB.formatMoney = (cents, format = BB.moneyFormat || '${{amount}}') => {
  const number = (decimals, thousands, decimal) => {
    const [whole, fraction] = (Number(cents) / 100).toFixed(decimals).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? grouped + decimal + fraction : grouped;
  };
  const formats = {
    amount: () => number(2, ',', '.'),
    amount_no_decimals: () => number(0, ',', '.'),
    amount_with_comma_separator: () => number(2, '.', ','),
    amount_no_decimals_with_comma_separator: () => number(0, '.', ','),
    amount_with_apostrophe_separator: () => number(2, "'", '.'),
    amount_no_decimals_with_space_separator: () => number(0, ' ', ','),
    amount_with_space_separator: () => number(2, ' ', ','),
    amount_with_period_and_space_separator: () => number(2, ' ', '.'),
  };
  const text = format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => (formats[key] || formats.amount)());
  const holder = document.createElement('span');
  holder.innerHTML = text;
  return holder.textContent;
};

BB.announce = (message) => {
  const region = $('[data-bb-live-region]');
  if (region) region.textContent = message;
};

/* Dialogs: native <dialog> gives focus trapping, Escape and an inert page for free. */
BB.openDialog = (dialog, opener) => {
  if (!dialog || dialog.open) return;
  dialog.bbOpener = opener || document.activeElement;
  dialog.showModal();
  document.documentElement.classList.add('bb-lock');
  if (dialog.bbOpener && dialog.bbOpener.hasAttribute('aria-expanded')) dialog.bbOpener.setAttribute('aria-expanded', 'true');
};

document.addEventListener(
  'close',
  (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.hasAttribute('data-bb-dialog')) return;
    if (!$('dialog[data-bb-dialog][open]')) document.documentElement.classList.remove('bb-lock');
    const opener = dialog.bbOpener;
    if (opener && opener.isConnected) {
      if (opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
  },
  true
);

const closeMegaMenus = (except) => {
  $$('[data-bb-toggle][aria-expanded="true"]').forEach((button) => {
    if (button === except) return;
    button.setAttribute('aria-expanded', 'false');
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = true;
  });
};

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const opener = target.closest('[data-bb-open]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('aria-controls'));
    if (dialog) {
      event.preventDefault();
      BB.openDialog(dialog, opener);
      const field = $('input[type="search"]', dialog);
      if (field) field.focus();
    }
    return;
  }

  const closer = target.closest('[data-bb-close]');
  if (closer) {
    const dialog = closer.closest('dialog');
    if (dialog) dialog.close();
    return;
  }

  if (target instanceof HTMLDialogElement && target.hasAttribute('data-bb-dialog')) {
    const box = target.getBoundingClientRect();
    const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
    if (!inside || target.classList.contains('bb-lightbox')) target.close();
    return;
  }

  const toggle = target.closest('[data-bb-toggle]');
  closeMegaMenus(toggle);
  if (toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    if (panel) panel.hidden = !open;
    return;
  }

  const accordion = target.closest('[data-bb-acc]');
  if (accordion) {
    const open = accordion.getAttribute('aria-expanded') !== 'true';
    const group = accordion.closest('[data-bb-acc-single]');
    if (open && group) {
      $$('[data-bb-acc][aria-expanded="true"]', group).forEach((other) => {
        other.setAttribute('aria-expanded', 'false');
        const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        if (otherPanel) otherPanel.hidden = true;
      });
    }
    accordion.setAttribute('aria-expanded', String(open));
    const panel = document.getElementById(accordion.getAttribute('aria-controls'));
    if (panel) panel.hidden = !open;
    return;
  }

  const play = target.closest('[data-bb-play]');
  if (play) {
    playMedia(play.closest('[data-bb-media]'), play);
    return;
  }

  const zoom = target.closest('[data-bb-lightbox]');
  if (zoom) openLightbox(zoom);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeMegaMenus();
});

/* Media slots */
const playMedia = (slot, button) => {
  if (!slot) return;
  const host = slot.dataset.bbEmbed;
  if (host) {
    const id = encodeURIComponent(slot.dataset.embedId);
    const frame = document.createElement('iframe');
    frame.src = host === 'vimeo' ? `https://player.vimeo.com/video/${id}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.title = button.getAttribute('aria-label') || '';
    slot.append(frame);
    button.remove();
    frame.focus();
    return;
  }
  const video = $('video', slot);
  if (!video) return;
  video.controls = true;
  video.play().catch(() => {});
  button.remove();
  video.focus();
};

const videoObserver =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && !reduceMotion.matches) {
              video.muted = true;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      )
    : null;

const initMedia = (root = document) => {
  if (!videoObserver) return;
  $$('video[data-bb-autoplay]', root).forEach((video) => videoObserver.observe(video));
};

const openLightbox = (trigger) => {
  const dialog = document.getElementById('bb-lightbox');
  const source = $('[data-bb-media]', trigger.parentElement);
  if (!dialog || !source) return;
  const copy = source.cloneNode(true);
  $$('img', copy).forEach((image) => {
    image.sizes = '100vw';
    image.loading = 'eager';
  });
  $('[data-bb-lightbox-body]', dialog).replaceChildren(copy);
  BB.openDialog(dialog, trigger);
};

/* Announcement rotation */
const rotators = new WeakMap();
const initRotators = (root = document) => {
  $$('[data-bb-rotate]', root).forEach((list) => {
    if (rotators.has(list) || reduceMotion.matches) return;
    const items = $$('.bb-announce__item', list);
    if (items.length < 2) return;
    let index = 0;
    let paused = false;
    list.addEventListener('mouseenter', () => (paused = true));
    list.addEventListener('mouseleave', () => (paused = false));
    list.addEventListener('focusin', () => (paused = true));
    list.addEventListener('focusout', () => (paused = false));
    const timer = window.setInterval(() => {
      if (!list.isConnected) return window.clearInterval(timer);
      if (paused || document.hidden) return;
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, Number(list.dataset.bbRotate) * 1000);
    rotators.set(list, timer);
  });
};

/* Header */
const initHeader = () => {
  const header = $('[data-bb-header]');
  if (!header) return;
  const setHeight = () => document.documentElement.style.setProperty('--bb-header-h', header.classList.contains('bb-header--sticky') ? `${header.offsetHeight}px` : '0px');
  setHeight();
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(header);
  if (header.classList.contains('bb-header--overlay')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
};

/* Cart */
const cartDrawer = () => $('[data-bb-cart]');

const renderCart = (html) => {
  const drawer = cartDrawer();
  if (!drawer || !html) return;
  const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bb-cart-inner]');
  const current = $('[data-bb-cart-inner]', drawer);
  if (!next || !current) return;
  current.replaceWith(next);
  if (drawer.open && !drawer.contains(document.activeElement)) {
    const close = next.querySelector('[data-bb-close]');
    if (close) close.focus();
  }
  setCartCount(Number(next.dataset.count));
};

const setCartCount = (count) => {
  $$('[data-bb-cart-count]').forEach((node) => (node.textContent = String(count)));
  document.dispatchEvent(new CustomEvent('bb:cart:updated', { detail: { count } }));
};

const cartRequest = async (url, payload) => {
  const drawer = cartDrawer();
  const body = { ...payload };
  if (drawer) {
    body.sections = drawer.dataset.sectionId;
    body.sections_url = window.location.pathname;
    drawer.setAttribute('aria-busy', 'true');
  }
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || BB.strings.cartError);
    if (drawer && data.sections) renderCart(data.sections[drawer.dataset.sectionId]);
    return data;
  } finally {
    if (drawer) drawer.removeAttribute('aria-busy');
  }
};

const showCartError = (message) => {
  const drawer = cartDrawer();
  const node = drawer && $('[data-bb-cart-error]', drawer);
  if (!node) return;
  node.textContent = message;
  node.hidden = false;
};

BB.cart = {
  hasDrawer: () => Boolean(cartDrawer()),
  open: (opener) => BB.openDialog(cartDrawer(), opener),
  async add(items, opener) {
    const data = await cartRequest(BB.routes.cartAdd + '.js', { items });
    if (cartDrawer()) BB.cart.open(opener);
    else window.location.assign(BB.routes.cart);
    return data;
  },
  change: (line, quantity) => cartRequest(BB.routes.cartChange + '.js', { line, quantity }),
  update: (payload) => cartRequest(BB.routes.cartUpdate + '.js', payload),
};

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const cartLink = target.closest('[data-bb-cart-open]');
  if (cartLink && cartDrawer()) {
    event.preventDefault();
    BB.cart.open(cartLink);
    return;
  }

  const lineButton = target.closest('[data-bb-line-qty]');
  if (lineButton) {
    BB.cart.change(Number(lineButton.dataset.bbLine), Number(lineButton.dataset.bbLineQty)).catch((error) => showCartError(error.message));
    return;
  }

  const addButton = target.closest('[data-bb-add]');
  if (addButton) {
    BB.cart.add([{ id: Number(addButton.dataset.bbAdd), quantity: 1 }], addButton).catch((error) => showCartError(error.message));
    return;
  }

  const removeCode = target.closest('[data-bb-discount-remove]');
  if (removeCode) {
    const form = $('[data-bb-discount-form]', cartDrawer());
    const codes = (form ? form.dataset.codes : '').split(',').filter((code) => code && code !== removeCode.dataset.bbDiscountRemove);
    BB.cart.update({ discount: codes.join(',') }).catch((error) => showCartError(error.message));
  }
});

document.addEventListener('change', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  if (target.matches('[data-bb-line-input]')) {
    BB.cart.change(Number(target.dataset.bbLine), Math.max(0, Number(target.value) || 0)).catch((error) => showCartError(error.message));
  } else if (target.matches('[data-bb-cart-note]')) {
    BB.cart.update({ note: target.value }).catch((error) => showCartError(error.message));
  } else if (target.matches('[data-bb-cart-attr]')) {
    const name = target.name.replace(/^attributes\[(.*)\]$/, '$1');
    const value = target.type === 'checkbox' ? (target.checked ? target.value : '') : target.value;
    BB.cart.update({ attributes: { [name]: value } }).catch((error) => showCartError(error.message));
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-bb-discount-form]')) return;
  event.preventDefault();
  const code = new FormData(form).get('discount').toString().trim();
  if (!code) return;
  const codes = form.dataset.codes.split(',').filter(Boolean);
  if (!codes.includes(code)) codes.push(code);
  BB.cart
    .update({ discount: codes.join(',') })
    .then((cart) => {
      const applied = (cart.discount_codes || []).find((entry) => entry.code.toLowerCase() === code.toLowerCase());
      if (!applied || applied.applicable === false) showCartError(BB.strings.cartError);
    })
    .catch((error) => showCartError(error.message));
});

/* Skip link lands on the first content section, after the header chrome. */
document.addEventListener('click', (event) => {
  const skip = event.target instanceof Element ? event.target.closest('.bb-skip') : null;
  if (!skip) return;
  const first = $('.bb-page > .shopify-section:not(.bb-sh-announce):not(.bb-sh-header) .bb-section');
  if (!first) return;
  event.preventDefault();
  first.setAttribute('tabindex', '-1');
  first.focus();
  first.scrollIntoView();
});

const init = (root = document) => {
  initMedia(root);
  initRotators(root);
};

init();
initHeader();
document.addEventListener('shopify:section:load', (event) => {
  init(event.target);
  if ($('[data-bb-header]', event.target)) initHeader();
});
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target;
  if (item instanceof Element && item.classList.contains('bb-announce__item')) {
    $$('.bb-announce__item', item.parentElement).forEach((other) => other.classList.toggle('is-active', other === item));
  }
});
